import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from 'components/Warrant/Warrant.scss';
import classNames from 'classnames';

const Warrant = memo(({ armsUrl, byAppointmentTo, textWithLeftAlignment }) => {
  const captionText = `By Appointment to ${byAppointmentTo} Grocer and Wine & Spirit Merchants Waitrose Limited, London and Bracknell`;
  return (
    <figure
      className={classNames(styles.warrant, {
        [styles.leftAlignment]: textWithLeftAlignment,
      })}
    >
      <img className={styles.arms} src={armsUrl} alt={captionText} />
      <figcaption
        className={classNames(styles.caption, {
          [styles.leftAlignment]: textWithLeftAlignment,
        })}
      >
        By Appointment to
        <br />
        {byAppointmentTo}
        <br />
        Grocer and Wine & Spirit Merchants
        <br />
        Waitrose Limited, London and Bracknell
      </figcaption>
    </figure>
  );
});

Warrant.displayName = 'Warrant';

Warrant.propTypes = {
  armsUrl: PropTypes.string.isRequired,
  byAppointmentTo: PropTypes.string.isRequired,
  textWithLeftAlignment: PropTypes.boolean,
};

export default Warrant;
